import React from 'react'

const UnknownUser: React.FC = () => (
  <div className="container" style={{ textAlign: 'center', padding: '3rem 1rem' }}>
    <h1 style={{ color: '#b91c1c', marginBottom: '1rem' }}>Who are you?</h1>
    <p style={{ fontSize: '1.15rem', color: '#444', marginBottom: '1.5rem' }}>
      Get in touch with Koko + Lbop so they can add you to the nice list.
    </p>
  </div>
)

export default UnknownUser
